import { render } from "./MainLayout.vue?vue&type=template&id=840c0718"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script